import { SerializedAspectInstance } from '@xlearn/common';

export const PlayerModuleSymbol = Symbol.for('PlayerModule')

export interface PlayerModule {
  name: string
  init?(): void
  start(instance: SerializedAspectInstance): void
  reset(instance: SerializedAspectInstance): void
  stop(): Promise<void>
}
